import { IconButton, Tooltip } from '@material-ui/core'
import { metodoPrograma } from '../../../components/api'
import Programa from '../../../components/Programa/Programa'
import Table from '../../../components/Table'
import { isEqual } from 'lodash'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack, MdDelete } from 'react-icons/md'
import Edicao from './Edicao'
import { IoReload } from 'react-icons/io5'

const TipoUsuarioSistema = () => {
  const [lista, setLista] = useState([])

  const buscaLista = useCallback(async () => {
    const res = await metodoPrograma('lista')
    setLista(res.lista || [])
  }, [])

  useEffect(() => {
    buscaLista()
  }, [buscaLista])

  const exclui = (lista) => async (e) => {
    const dados = {
      idTipoUsuario: lista[0],
      idContratante: lista[1],
    }
    e.stopPropagation()
    if (
      !window.confirm('Mas você tem CERTEZA que deseja excluir este usuário???')
    )
      return
    await metodoPrograma('exclui', dados)
    await buscaLista()
  }

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [programaAberto, setProgramaAberto] = useState([])

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar Programa">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  const voltar = () => {
    buscaLista()
    setTela('lista')
    setProgramaAberto(undefined)
  }

  const handleClick = async (_, linha) => {
    setProgramaAberto(linha)
    setTela('opcoes')
  }
  return (
    <Programa codigo="CtrlTipoUsuarioSistema" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Table
          dados={lista}
          head={['Name', 'Type', 'Status', '']}
          line={(l) => [l[1], l[2], l[3], '']}
          columnOptions={[
            {
              alias: 3,
              customJsx: ({ linhaOriginal }) => (
                <IconButton size="small" onClick={exclui(linhaOriginal)}>
                  {linhaOriginal[4] ? <IoReload /> : <MdDelete />}
                </IconButton>
              ),
            },
          ]}
          onClick={handleClick}
        />
      ) : (
        <Edicao {...{ programaAberto, voltar }} />
      )}
    </Programa>
  )
}

export default memo(TipoUsuarioSistema, isEqual)
